import React from "react";
import { selectors } from "@Src/redux/reducers";
import { useSelector, useDispatch } from "react-redux";
import Loading from "@Components/loading";
import actions from "@Src/redux/rootActions";

const { fetchFavorites } = actions.favorites;

/**
 * GetFavorites component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The child components to render.
 * @returns {React.ReactNode} The rendered component.
 */
const GetFavorites = ({ children }) => {
  const [readyToContinue, setReadyToContinue] = React.useState(false);
  const userIsAuthenticated = useSelector(selectors.hasAuthenticatedUser);
  const dispatch = useDispatch();

  // Fetch Favorites
  const getFavs = React.useCallback(async () => {
    if (userIsAuthenticated) {
      dispatch(fetchFavorites());
    }
  }, [dispatch, userIsAuthenticated]);

  // Fetch Favorites
  React.useEffect(() => {
    if (userIsAuthenticated && !readyToContinue) {
      setReadyToContinue(true);
      getFavs();
    } else if (!userIsAuthenticated && !readyToContinue) {
      setReadyToContinue(true);
    }
  }, [userIsAuthenticated, readyToContinue, getFavs, setReadyToContinue]);

  if (!readyToContinue) {
    return <Loading />;
  }
  return children;
};

export default GetFavorites;
